import { Command, Search } from "lucide-react";

interface TopBarProps {
  runningCount?: number;
  queueCount?: number;
  successRate?: number;
  onSearchClick?: () => void;
}

export function TopBar({
  runningCount = 0,
  queueCount = 0,
  successRate = 100,
  onSearchClick,
}: TopBarProps) {
  return (
    <header className="flex h-12 items-center gap-4 border-b border-[var(--border)] bg-[#101318] px-4">
      {/* Logo */}
      <div className="flex items-center gap-2">
        <span className="text-lg font-semibold" style={{ color: "#7dd3fc" }}>
          DataFlow
        </span>
        <LiveIndicator />
      </div>

      {/* Metrics */}
      <div className="ml-auto flex items-center gap-6">
        <MetricItem label="Running" value={runningCount} />
        <MetricItem label="Queue" value={queueCount} />
        <MetricItem label="Success rate" value={`${successRate.toFixed(1)}%`} />
      </div>

      {/* Search Button */}
      <button
        onClick={onSearchClick}
        className="flex h-8 items-center gap-2 rounded-md border border-[var(--border)] bg-[#0c0f14] px-3 text-xs text-[var(--muted)] hover:text-slate-100"
        type="button"
      >
        <Search className="size-3.5" />
        <span className="hidden sm:inline">Search</span>
        <kbd className="ml-1 rounded border border-[var(--border)] bg-[#1a1e25] px-1.5 py-0.5 text-[10px]">
          <Command className="inline size-3" />
          K
        </kbd>
      </button>
    </header>
  );
}

function LiveIndicator() {
  return (
    <div className="flex items-center gap-1.5">
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
      </span>
      <span className="text-[10px] text-emerald-400">Live</span>
    </div>
  );
}

interface MetricItemProps {
  label: string;
  value: string | number;
}

function MetricItem({ label, value }: MetricItemProps) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-[11px] text-[var(--muted)]">{label}</span>
      <span className="text-sm font-medium text-slate-200">{value}</span>
    </div>
  );
}
